/* eslint-disable no-restricted-syntax */
/* eslint-disable no-continue */
import { intersection, each, includes } from 'lodash';
import { getAllowedRoles } from '@/../config/userRoles';

export const getApplicationHubs = () => {
  const hubs = [
    {
      id: 'operations',
      label: 'Operations',
    },
    {
      id: 'product-admin',
      label: 'Product admin',
    },
  ];
  if (isAllowedUserRole(getAllowedRoles('userManagement'))) {
    hubs.push({
      id: 'user-management',
      label: 'User management',
    });
  }
  return hubs;
};

export const getProductAdminLinks = () => [
  {
    key: 'market-templates',
    to: { name: 'market-templates' },
    label: 'Market Templates',
    allowedUserRoles: getAllowedRoles('templates'),
  },
  {
    key: 'mapping',
    label: 'Mapping',
    items: [
      {
        to: {
          name: 'eventsMapping',
        },
        label: 'Events mapping',
      },
      {
        to: {
          name: 'competitorsMapping',
        },
        label: 'Competitors mapping',
      },
      {
        to: {
          name: 'regionsMapping',
        },
        label: 'Regions mapping',
      },
      {
        to: {
          name: 'competitionsMapping',
        },
        label: 'Competitions mapping',
      },
      {
        to: {
          name: 'playersMapping',
        },
        label: 'Players mapping',
      },
    ],
    allowedUserRoles: getAllowedRoles('mapping'),
  },
  {
    key: 'configuration',
    label: 'Configuration',
    items: [
      {
        to: {
          name: 'market-display',
        },
        label: 'Market Display',
        allowedUserRoles: getAllowedRoles('marketConfig'),
      },
      {
        to: {
          name: 'selection-display',
        },
        label: 'Selection Display',
        allowedUserRoles: getAllowedRoles('selectionDisplay'),
      },
      {
        to: {
          name: 'market-groups',
        },
        label: 'Market Groups',
        allowedUserRoles: getAllowedRoles('marketConfig'),
      },
      {
        to: { name: 'competition-configuration' },
        label: 'Competition Configuration',
        allowedUserRoles: getAllowedRoles('competitionConfiguration'),
      },
      {
        to: {
          name: 'teamManualEdit',
        },
        label: 'Team Edit',
        allowedUserRoles: getAllowedRoles('manualEdit'),
      },
      {
        to: {
          name: 'playerManualEdit',
        },
        label: 'Player Edit',
        allowedUserRoles: getAllowedRoles('manualEdit'),
      },
    ],
  },
];

export const getOperationsLinks = () => [
  {
    key: 'events_book_events',
    to: { name: 'events_book_events' },
    label: 'Events',
    allowedUserRoles: getAllowedRoles('events'),
  },
  {
    key: 'specials',
    to: { name: 'specials' },
    label: 'Specials',
    allowedUserRoles: getAllowedRoles('specials'),
  },
  {
    key: 'bet-ticker',
    to: { name: 'bet-ticker' },
    label: 'Bet Ticker',
    allowedUserRoles: getAllowedRoles('betTicker'),
  },
  {
    key: 'liability',
    label: 'Liability',
    allowedUserRoles: getAllowedRoles('liability'),
    items: [
      {
        to: { name: 'liability' },
        label: 'Event liability',
      },
      {
        to: { name: 'specials-liability' },
        label: 'Specials liability',
      },
    ],
  },
  {
    key: 'customer-profiling',
    to: { name: 'customer-profiling-list' },
    label: 'Customer Profiling',
    allowedUserRoles: getAllowedRoles('customerProfiling'),
  },
  {
    key: 'odds-checker',
    label: 'Odds Checker',
    allowedUserRoles: getAllowedRoles('oddsChecker'),
    items: [
      {
        to: {
          name: 'core-markets',
        },
        label: 'Core markets',
      },
      {
        to: {
          name: 'player-props',
        },
        label: 'Player props',
      },
    ],
  },
  {
    key: 'manual-resulting',
    to: { name: 'manual-resulting' },
    label: 'Manual Resulting',
    allowedUserRoles: getAllowedRoles('manualResulting'),
  },
];

export const getUserManagementLinks = () => [
  {
    key: 'user-management',
    to: { name: 'user-management' },
    label: 'Users',
    allowedUserRoles: getAllowedRoles('userManagement'),
  },
  {
    key: 'user-management-activity-log',
    to: { name: 'user-management-activity-log' },
    label: 'Activity Log',
    allowedUserRoles: getAllowedRoles('userManagement'),
  },
];

export const getAllowedLinks = (userRoles, links) => {
  const allowedLinks = [];
  for (const link of links) {
    if (link.allowedUserRoles && !intersection(userRoles, link.allowedUserRoles).length) {
      continue;
    }

    if (!link.items) {
      allowedLinks.push(link);
      continue;
    }

    const allowedSublinks = getAllowedLinks(userRoles, link.items);
    if (!allowedSublinks.length) {
      continue;
    }

    allowedLinks.push({
      ...link,
      items: allowedSublinks,
    });
  }
  return allowedLinks;
};

export const isAllowedUserRole = (allowedUserRoles) => {
  const huddleRoles = localStorage.getItem('huddleRoles');
  const userRoles = huddleRoles ? huddleRoles.split(',') : [];
  let userAllowedRoute = false;
  each(userRoles, (role) => {
    if (includes(allowedUserRoles, role)) userAllowedRoute = true;
  });
  return userAllowedRoute;
};
